import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * The release named in the URL, or null when none is. A read targets exactly one
 * release, so a URL that repeats the key collapses to the first value rather than
 * forming a request the backend rejects.
 */
export const parseReleaseId = (searchString: string): string | null => {
  const value = new URLSearchParams(searchString).get('release')?.trim();
  return value ? value : null;
};

export const useReleaseId = (): string | null => {
  const [searchParams] = useSearchParams();
  return useMemo(() => parseReleaseId(searchParams.toString()), [searchParams]);
};
